import { Outlet } from "react-router";

import CustomerLogin from "legacy/containers/CustomerLogin";

const LegacyLoginLayout = () => (
  <CustomerLogin>
    <Outlet />
  </CustomerLogin>
);

export { LegacyLoginLayout };
